import './static_pages.sass'
